var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DualRowPackageWithDifferentPadGeneratorInteractionModel = require('../dualRowPackageWithDifferentPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var Sot223PadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DualRowPackageWithDifferentPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(Sot223PadGeneratorInteractionModel, DualRowPackageWithDifferentPadGeneratorInteractionModel);
Sot223PadGeneratorInteractionModel.$class = 'Sot223PadGeneratorInteractionModel';
module.exports = Sot223PadGeneratorInteractionModel;

Sot223PadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount, [4, 5, 6])];
};

Sot223PadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    var normalTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), false, this.padHeightMin, false, this.padHeightMax, this.userSettingsModel.distanceUnit);
    var tabWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b1', this.LCLZ('tabWidth', 'Tab Width'), false, this.oddPadHeightMin, false, this.oddPadHeightMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalWidth, tabWidth];
};

Sot223PadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintSot223));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForOddPadLengthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForOddPadWidthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadPitchInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};